<template>
    <div :class="getClass">
        <!--<button v-if="showButton" type="button" :disabled="disabled" @click="onButtonClick" :class="clazz" >{{buttonText}}</button>-->
        <ur-button v-if="showButton" small :disabled="disabled" @click="onButtonClick" :text="buttonText"/>
        <span v-else >{{descText}}</span>
    </div>
</template>
<script>
import Base from './CMP_AIS_00005_COMP_BASE';

export default {
    name:'CMP_AIS_00005_C04',
    extends:Base,
    components:{},
    props:{
        //props : ['row','value','text'], 
    },
    data(){
        return {
        }
    },
    created(){},
    mounted(){},
    computed:{
        clazz(){
            let result = [];
            result.push('btn');
            result.push('btn_border');
            result.push('btn_s');
            if(this.row.scheduleStatus === 'Y') {
                result.push('btn_disabled');
            }
            return result;
        },
        showButton(){
            if(this.row.isNewNumber) {
                return true;
            } else if(!this.row.oldStatusCode || this.row.oldStatusCode != 'D') {
                return false;
            } else if(this.row.isChannelChange === true) {
                return false;
            } else {
                return true;
            }
        },
        disabled(){
            if(this.row.scheduleStatus === 'Y') {
                return true;
            }
            return false;
        },
        descText(){
            if(this.row.isChannelChange === true) {
                return  '채널 변경중';
            } else {
                switch(this.row.oldStatusCode) {
                    case 'B':
                        return '신규 신청중';
                    case 'C':
                        return '채널 변경중';
                    case 'E':
                        return '해지 신청중';
                    default:
                        return '';
                }
            }
        },
        buttonText(){
            if(this.row.isNewNumber && this.row.isNewNumber === true) {
                return '삭제';
            } else {
                switch(this.row.statusCode) {
                    case 'D':
                        return '해지';
                    case 'E':
                        return '해지취소'
                    default:
                        return '';
                }
            }
        },
    },
    methods:{
        onButtonClick(){
            console.log('CMP_AIS_00005_C04 : onButtonClick');
            let parent = this.getComponent('ServiceRequestNewModal');
            console.log('parent', parent);
            switch(this.row.statusCode) {
                case 'B':
                    console.log('Status Code : B');
                    this.row.statusCode = 'B';
                    //parent.items[this.row.__idx].statusCode = this.row.statusCode;
                    console.log('Status Code Setted');
                    parent.onClickRowDel(this.row.__idx);
                    break;
                case 'D':
                    console.log('Status Code : D');
                    this.row.statusCode = 'E';
                    //parent.items[this.row.__idx].statusCode = this.row.statusCode;
                    console.log('Status Code Setted');
                    parent.onClickFire(this.row.__idx, 'E');
                    break;
                case 'E':
                    console.log('Status Code : E');
                    this.row.statusCode = 'D';
                    //parent.items[this.row.__idx].statusCode = this.row.statusCode;
                    console.log('Status Code Setted');
                    parent.onClickFire(this.row.__idx, 'D');
                    break;
                default:
                    console.log('Status Code Default : '+this.row.statusCode);
                    return;
            }
        },
    },
}
</script>
<style scoped>
    .ur-button--small {
        height: 24px;
    }
    .btn {
        display: inline-block;
        text-align: center;
        white-space: nowrap;
    }
    .btn_border {
        border: 1px solid #8B9ABC;
    }
    .btn_border:hover {
        background-color: #F7F7F7;
    }
    .btn_s {
        border-radius: 2px;
        min-width: 48px;
        height: 24px;
        line-height: 22px;
        padding: 0 8px;
        font-size: 12px;
        font-weight: 400;
    }
    .btn_disabled {
        border-color: #CCCCCC;
    }
</style>